import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import Geosuggest from 'react-geosuggest';

import {I18N, RADIUS_SEARCH} from '../globals/wp';
import { locationRoute } from '../utils/data/routes';

import GetLocation from './get-location';
import RadiusSelector from './radius-selector';

import styles from './typeahead.pcss';
import * as events from "../utils/events";

/**
 * The typeahead component. Powered by react geosuggest.
 */

export default class Typeahead extends Component {
	static propTypes = {
		handleUpdate: PropTypes.func,
		navigate: PropTypes.func,
		query: PropTypes.string,
		radius: PropTypes.string.isRequired,
	};

	static defaultProps = {
		handleUpdate: () => {},
		navigate: () => {},
		query: '',
	};

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.addEventListener('modern_tribe/locator/update_query', this.handleQueryChange);
	}

	componentWillUnmount() {
		document.removeEventListener('modern_tribe/locator/update_query', this.handleQueryChange);
	}

	handleRadiusChange = (radius) => {
		events.trigger({ event: 'modern_tribe/locator/update_radius', native: false, data: { radius } });
	};

	handleQueryChange = (e) => {
		this.suggest.update(e.detail.query);
		// geosuggest internals appear to require this delay after doing an update to select the suggestions it gens,
		// very annoying, they are working on these methods and lots of reports.
		_.delay(() => this.suggest.selectSuggest(), 10);
	};

	/**
	 * clears the input
	 * @param e
	 */
	clearInput = (e) => {
		e.preventDefault();
		this.suggest.update('');
		this.props.navigate(locationRoute());
	};

	/**
	 * Updates location on user selection of an address.
	 * @param data
	 */
	updateLocator = (data) => {
		this.props.navigate(locationRoute(data, this.props.radius)).then(() => this.props.handleUpdate());
	};

	render() {
		const iconClasses = classNames({
			'location-search-icon': true,
			'icon': true,
			'icon-search': true,
			[styles.icon]: true,
		});
		const clearClasses = classNames({
			'icon': true,
			'icon-cross': true,
			[styles.clear]: true,
		});

		return (
			<div className={styles.container}>
				<label className={styles.label} id="all-locations-list__typeahead-label">
					{I18N.geolocation_label}
				</label>
				<Geosuggest
					ref={(c) => { this.suggest = c; }}
					placeholder={I18N.location_input_placeholder}
					initialValue={decodeURIComponent(this.props.query)}
					className={styles.suggest}
					inputClassName={styles.searchInput}
					onSuggestSelect={this.updateLocator}
					id="all-locations-list__typeahead"
					aria-labelledby="all-locations-list__typeahead-label"
					autoComplete="off"
					autoActivateFirstSuggest
				/>
				<button className={clearClasses} onClick={this.clearInput} />
				<i className={iconClasses} />
				<div className={styles.footer}>
					<RadiusSelector
						radius={parseInt(this.props.radius, 10)}
						handleUpdateRadius={this.handleRadiusChange}
					/>
					<GetLocation
						radius={this.props.radius}
						{...this.props}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/typeahead.js